import PropTypes from 'prop-types';
import React from 'react';

import Queue from '../../../../queue/QueueContainer';
import config from '../../../../../config';
import { t } from '../../../../../modules/infra/i18n';

const TimeTrackReport = ({
  canInstantDownloadCsv,
  startDate,
  endDate,
  dateToString,
}) => (
  <div className="u-text-center">
    <div display-if={!canInstantDownloadCsv}>
      <p className="u-mb-">
        <em>
          {t('reports:time_track_report.csv_export_info', { days: config.exportReportDays })}
        </em>
      </p>
      <Queue
        display-if={!canInstantDownloadCsv}
        name="reports"
        label={t('reports:time_track_report.label')}
        btnLabel={t('reports:time_track_report.export_button')}
        btnClass="c-btn c-btn--primary"
        jobName="time-track-report"
        filters={{ startDate: dateToString(startDate), endDate: dateToString(endDate) }}
      />
    </div>
  </div>
);

TimeTrackReport.propTypes = {
  canInstantDownloadCsv: PropTypes.bool.isRequired,
  dateToString: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default TimeTrackReport;
